import React from 'react';
import {
  Accordion,
  Button,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import ReactTable from 'Common/ReactTableWrapper';
import { OnHandReportTransactionDetailsEnum } from 'Common/FieldEnum';
import { DatePickerField, DropdownField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { DatePickerCustomButton } from 'Components';
import { makeOptionsData } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';

const TransactionDetailsReportComponent = props => {
  const {
    handleCollapsePanelClick,
    activeIndexes,
    clearFilters,
    columns,
    onChangeOfToDT,
    onChangeOfFromDT,
    loadingOnHandTransactionDetailsItems,
    onHandTransactionDetailsItems,
    handleSubmit,
    handleChangeTypes,
    transactionTypesData,
    gridPreferenceLoading,
    gridPreferenceSubmitting,
    gridName,
    loadingTransactionTypesData,
    fromDateMaxTranDetail,
    toDateMinTranDetail,
  } = props;

  const loading =
    loadingOnHandTransactionDetailsItems ||
    gridPreferenceLoading ||
    gridPreferenceSubmitting;
  return (
    <Form onSubmit={handleSubmit}>
      <Accordion fluid styled>
        <Accordion.Title
          active={activeIndexes.indexOf(0) !== -1}
          index={0}
          onClick={handleCollapsePanelClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Filter By</span>
        </Accordion.Title>

        <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
          <Grid className="grid-spacing">
            <Grid.Row columns={2}>
              <Grid.Column>
                <div style={{ paddingTop: 25 }}>
                  <Header as="h4">Transaction Date Range</Header>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  component={DatePickerField}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  label={'From:'}
                  name={OnHandReportTransactionDetailsEnum.FromDt}
                  onChange={onChangeOfFromDT}
                  type={'text'}
                  maxDate={fromDateMaxTranDetail}
                  customInput={<DatePickerCustomButton />}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  component={DatePickerField}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  label={'To:'}
                  name={OnHandReportTransactionDetailsEnum.ToDt}
                  onChange={onChangeOfToDT}
                  type={'text'}
                  minDate={toDateMinTranDetail}
                  customInput={<DatePickerCustomButton />}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column width={12}>
                <Field
                  options={makeOptionsData(transactionTypesData)}
                  placeholder="Select types"
                  search
                  component={DropdownField}
                  name={OnHandReportTransactionDetailsEnum.Types}
                  selection
                  fluid
                  multiple
                  loading={loadingTransactionTypesData}
                  label={'Transaction Type'}
                  onChange={handleChangeTypes}
                />
              </Grid.Column>
              <Grid.Column
                floated={'right'}
                textAlign={'right'}
                verticalAlign={'bottom'}
                width={4}
              >
                <Button
                  content="Clear Filters"
                  onClick={clearFilters}
                  type={'button'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>
      </Accordion>

      <Divider horizontal />
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <ReactTable
              defaultPageSize={20}
              minRows={0}
              loading={loading}
              loadingText={loading ? 'Loading...' : ''}
              noDataText={loading ? '' : 'No items found!'}
              data={onHandTransactionDetailsItems}
              resizable={false}
              className="-striped -highlight"
              columns={columns}
              showPageSizeOptions={true}
              draggableColumns={true}
              showHideColumn={true}
              menu={'hasCogs'}
              saveState={{
                tableName:
                  TableNamesEnum.ON_HAND_REPORT_TRANSACTION_DETAILS_TABLE,
              }}
              gridName={gridName}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

TransactionDetailsReportComponent.propTypes = {
  columns: PropTypes.array.isRequired,
  onHandTransactionDetailsItems: PropTypes.array.isRequired,
  transactionTypesData: PropTypes.array.isRequired,
  handleCollapsePanelClick: PropTypes.func,
  clearFilters: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  onChangeOfFromDT: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleChangeTypes: PropTypes.func,
  activeIndexes: PropTypes.array,
  gridName: PropTypes.string,
  loadingOnHandTransactionDetailsItems: PropTypes.bool,
  gridPreferenceLoading: PropTypes.bool,
  gridPreferenceSubmitting: PropTypes.bool,
  loadingTransactionTypesData: PropTypes.bool,
};

TransactionDetailsReportComponent.defaultProps = {
  handleCollapsePanelClick: () => {},
  clearFilters: () => {},
  onChangeOfToDT: () => {},
  onChangeOfFromDT: () => {},
  handleSubmit: () => {},
  handleChangeTypes: () => {},
  activeIndexes: 0,
  gridName: GridEnum.INV_OnHandReport_TransactionDetails_View,
  loadingOnHandTransactionDetailsItems: false,
  gridPreferenceLoading: false,
  gridPreferenceSubmitting: false,
  loadingTransactionTypesData: false,
};

export default TransactionDetailsReportComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/components/TransactionDetailsReport.js